<template>
    <div class="center-y">
        <ion-checkbox
            class="grey4-grey4-background custom-light-checkbox"
            ref="checkbox"
            v-model="checkboxValue"
            :name="name"
        />

        <span
            class="ml-1 cursor-pointer disable-text-select fs-smaller fw-b"
            :class="labelClass"
            @click="checkbox.$el.click()"
        >
            <slot/>
        </span>
    </div>
</template>

<script setup lang="ts">
import { IonCheckbox } from "@ionic/vue";
import { ref, computed, onMounted } from "vue";
import { useField } from "vee-validate";

import { CheckboxSimpleProps } from "@/types/props";
import { CheckboxSimpleEmits } from "@/types/emits";

const props = defineProps<CheckboxSimpleProps>()
const emit = defineEmits<CheckboxSimpleEmits>()

const checkbox = ref()

const checkboxValue = computed<boolean>({
    get: () => {
        if (!props.modelValue) return props.value ?? false
        return props.modelValue
    },
    set: (value) => {
        emit('update:modelValue', value)
        emit('change', value)
        handleChange(value);
    }
})

const { handleChange } = useField(props.name ?? '', undefined, {
    // Will make the checkbox set its value to true/false if it was checked or not
    type: 'checkbox',
    checkedValue: true,
    uncheckedValue: false,
});
</script>